import { React } from 'react';
import SideBar from '../../components/sideBar/SideBar';
import style from './admin.module.scss';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import UsersTable from '../../components/adminSects/users/UsersTable';
import SellsTable from '../../components/adminSects/sells/SellsTable';
import StandsTable from '../../components/adminSects/stands/StandsTable';
import Conference from '../../components/adminSects/conference/Conference';
import VisitsTable from '../../components/adminSects/visits/VisitsTable';
import ManageFeria from '../../components/adminSects/manageFeria/ManageFeria';


const Admin = () => {
  const { container, sectContainer, sect } = style;
  let { path } = useRouteMatch();

  return (
    <div className={container}>
      <SideBar />
      <div className={sectContainer}>
        <div className={sect}>
          <Switch>
            <Route path={`${path}/sells`} component={SellsTable} />
            <Route path={`${path}/stands`} component={StandsTable} />
            <Route path={`${path}/conference`} component={Conference} />
            <Route path={`${path}/visits`} component={VisitsTable} />
            <Route path={`${path}/manage`} component={ManageFeria} />
            <Route path={`${path}/`} component={UsersTable} />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Admin;
